import React, { useRef } from "react";
import { translate } from "../Services/translation";
import BuyButton from "../Containers/BuyButton.container";
import { useMediaQuery } from "react-responsive";

const ProductPointer = (props) => {
  const {
    campaignPrice,
    subtitle,
    heading,
    text,
    image,
    isstockbalanceabovelimit,
    mobileimage,
    linkUrl,
    recommendedPrice,
    reference,
    showbuybutton,
  } = props;
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const buyButtonRef = useRef(null);
  const isLarge = text != "";

  const handleProductAddToCart = () => {
    addToCart(buyButtonRef, product.addtocartarticlenumber);
  };

  return (
    <>
      <picture className="product-pointer__media">
        {isMobile ? (
          <source
            media="(max-width: 767px)"
            srcSet={mobileimage}
            alt={heading}
            data-aos="fade"
            data-aos-easing="linear"
            data-aos-offset="0"
            data-aos-duration="400"
          />
        ) : null}
        <img
          src={image}
          alt={heading}
          loading="lazy"
          data-aos="fade"
          data-aos-easing="linear"
          data-aos-offset="0"
          data-aos-duration="400"
        />
        <a href={linkUrl} className="product-pointer__link" />
      </picture>

      <div className={`product-pointer__content`}>

        <div className="product-pointer__text">
          {
            subtitle && <p className="product-pointer__subtitle" role="doc-subtitle">{subtitle}</p>
          }

          <h2 className={`product-pointer__heading`}>{heading}</h2>

          {
            text && <div className="product-pointer__editor" dangerouslySetInnerHTML={{ __html: text }}></div>
          }
        </div>

        <div className="product-pointer__footer">
          <div className={`product-card__price`}>
            {campaignPrice ? (
              <>
                <span className={`product-card__price--campaign`}>
                  {campaignPrice}
                </span>
                <span className={`product-card__price--original`}>
                  {recommendedPrice}
                </span>
              </>
            ) : (
              <span className={`product-card__price--recommended`}>
                {recommendedPrice}
              </span>
            )}
          </div>
          <div className="product-card__button-wrapper" ref={buyButtonRef}>
            {isstockbalanceabovelimit && showbuybutton ? (
              <BuyButton
                {...{
                  label: translate("product.buy.small"),
                  articleNumber: reference,
                  cssClass:
                    "button button--buy button--buy-small button--buy-icon button--buy-icon-small button--icon ",
                }}
                onClick={() => handleProductAddToCart()}
              />
            ) : (
              <BuyButton
                {...{
                  isShowMore: true,
                  label: translate("product.readMore"),
                  href: linkUrl,
                  cssClass:
                    "button button--buy button--buy-small button--buy-icon button--buy-icon-small button--icon ",
                }}
                onClick={(e) => handleProductClick(e)}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductPointer;
